(function (Drupal, $, once, drupalSettings) {
  var initialized;
  Drupal.behaviors.urone = {
    attach: function (context) {
      // Check if we're on a translated website.
      let isTranslated = false;

      // Base domain that the website is translated against.
      let baseDomain = '';

      // Attach query string parameters to login URL.
      let loginLink = document.querySelectorAll('a[href^="/saml/login"]');
      let logoutLink = document.querySelectorAll('a[href^="/saml/logout"]');
      let queryString = window.location.search;

      // Map of translated French website domains.
      // @todo should pull from Drupal config and output in drupalSettings.
      let urFrenchWebsites = {
        'unitedrentals.lndo.site': ['fr-unitedrentals.lndo.site'],
        'dev.unitedrentals.com': ['frca-dev.unitedrentals.com'],
        'stage.unitedrentals.com': ['frca-stage.unitedrentals.com'],
        'www.unitedrentals.com': ['fr.unitedrentals.com']
      };
      // Map of translated Spanish website domains.
      let urSpanishWebsites = {
        'unitedrentals.lndo.site': ['es-unitedrentals.lndo.site'],
        'dev.unitedrentals.com': ['esus-dev.unitedrentals.com'],
        'stage.unitedrentals.com': ['esus-stage.unitedrentals.com'],
        'www.unitedrentals.com': ['es.unitedrentals.com']
      };

      // Check if the current page is /login and redirect to translated subdomain if needed.
      if (window.location.pathname === '/login') {
        redirectLoginPage();
      }

      function redirectLoginPage() {
        const frenchDomains = Object.keys(urFrenchWebsites);
        const spanishDomains = Object.keys(urSpanishWebsites);
        const currentDomain = window.location.hostname;
        // Ignore if we are already on a translated subdomain.
        if (!frenchDomains.includes(currentDomain) && !spanishDomains.includes(currentDomain)) {
          return;
        }

        // Get the ReturnTo parameter from the query string
        const queryParams = new URLSearchParams(window.location.search);
        const returnTo = decodeURIComponent(queryParams.get('ReturnTo'));

        // Extract the RelayState parameter from the ReturnTo URL
        const relayStateParams = new URLSearchParams(returnTo);
        const relayState = decodeURIComponent(relayStateParams.get('RelayState'));

        // Check for the locale parameter in the RelayState URL
        const relayStateURL = new URL(relayState);
        const locale = relayStateURL.searchParams.get('locale');

        // Redirect to subdomain if locale exists
        if (locale) {
          const currentPagePath = window.location.pathname;
          let subdomain = '';
          if (locale === 'es') {
            subdomain = urSpanishWebsites[window.location.hostname];
          } else if (locale === 'fr') {
            subdomain = urFrenchWebsites[window.location.hostname];
          }

          if (subdomain && subdomain.length > 0) {
            const redirectURL = `https://${subdomain}${currentPagePath}${window.location.search}`;
            window.location.href = redirectURL;
          }
        }
      }

      // Strip `?check_logged_in=1` if in the query string for login links.
      if (queryString.length > 0) {
        queryString = queryString.replace('check_logged_in=1', '');
        // If all we have is `?` then remove it.
        if (queryString === '?') {
          queryString = '';
        }
      }

      // Check if we need to add locale to the queryString.
      // Check if the website is a translated French website in the object values.
      for (let key in urFrenchWebsites) {
        if (urFrenchWebsites[key].includes(window.location.hostname)) {
          isTranslated = true;
          // Add the locale to the query string. Mindful of the ? or &.
          queryString += queryString.includes('?') ? '&locale=fr' : '?locale=fr';
          baseDomain = key;
          updateLanguageSelector('Français');
        }
      }

      // Check if the website is a translated Spanish website in the object values.
      for (let key in urSpanishWebsites) {
        if (urSpanishWebsites[key].includes(window.location.hostname)) {
          isTranslated = true;
          // Add the locale to the query string. Mindful of the ? or &.
          queryString += queryString.includes('?') ? '&locale=es' : '?locale=es';
          baseDomain = key;
          updateLanguageSelector('Español');
        }
      }

      function updateLanguageSelector(value) {
        $('#account-menu-item--language-selector > a.account-menu-item--language-selector').attr('title', value);
        $('#account-menu-item--language-selector > a.account-menu-item--language-selector > span.menu-item__button-title--translation').html(value);
        $('#mobile-account-menu-item--language-selector span.menu-item__button-title--translation').html(value);
        $('#mobile-account-menu-item--language-selector > button[data-item-title="English"]').attr('data-item-title', value);

        // Update en home links.
        $("#mobile-account-menu-item--language-selector-panel a:contains('Inglés'), #mobile-account-menu-item--language-selector-panel a:contains('English')").attr('href', 'https://www.unitedrentals.com');
        $("#account-menu-item--language-selector a:contains('Inglés'), #account-menu-item--language-selector a:contains('English')").attr('href', 'https://www.unitedrentals.com');
      }

      // Home page exception - need to link to homepage new url.
      let loginDestination = encodeURIComponent(window.location.pathname + queryString);
      if (window.location.pathname === '/') {
        loginDestination = encodeURIComponent(`/new-home${queryString}`);
      }

      loginLink.forEach(function (link) {
        link.setAttribute('href', `/saml/login?destination=${loginDestination}`);
      });

      // If we're on a translated website then replace the domain in the login/logout links
      // with the base domain we're translating from.
      if (isTranslated) {
        loginLink.forEach(function (link) {
          link.setAttribute('href', `https://${baseDomain}${link.getAttribute('href')}`);
        });

        // Add base domain and locale to all logout links.
        logoutLink.forEach(function (link) {
          // We always want to logout to the homepage.
          let logoutDestination = encodeURIComponent(`/new-home${queryString}`);
          link.setAttribute('href', `https://${baseDomain}/saml/logout?destination=${logoutDestination}`);
        });
      }

      function focusKeyDown(e) {
        if ([9, 13, 32, 38, 40].indexOf(e.keyCode) !== -1) {
          $('body').addClass('keyboard-activated');
          $(window).on('mousedown.keyboard', focusMouseDown);
          $(window).off('keydown.keyboard');
        }
      }

      function focusMouseDown(e) {
        $('body').removeClass('keyboard-activated');
        $(window).on('keydown.keyboard', focusKeyDown);
        $(window).off('mousedown.keyboard');
      }

      $(window).on('keydown.keyboard', focusKeyDown);

      // Remove all svg IDs.
      $('svg').removeAttr('id');

      // Toggle class on body for if modal is open.
      $(window).on({
        'dialog:aftercreate': function (dialog, $element, settings) {
          $('body').addClass('ui-dialog-open');
        },
        'dialog:afterclose': function (dialog, $element, settings) {
          $('body').removeClass('ui-dialog-open');
        }
      });

      // adding IE workaround for "object fit" on component cards in Project Uptime
      const isIEorEdge = document.documentMode || /Edge/.test(navigator.userAgent) || /Edg/.test(navigator.userAgent);

      if (isIEorEdge) {
        $('.component-card.paragraph--view-mode-full .media--type-image img').each(function () {
          let $targetImage = $(this);
          $targetImage.addClass('component-card-image');
          let targetImageSrc = $targetImage.attr('src');
          let $targetParent = $targetImage.parent();
          $targetParent.addClass('component-card-image__wrapper');
          $targetParent.css('background-image', `url(${targetImageSrc})`);
        });
      }
      // Search page fix: Removed token that doesn't get replaced when there isn't a search string:
      var searchToken = document.querySelector('#search-token-term');
      if (searchToken) {
        if ((searchToken.innerHTML || '').replace(/^\s+/, '') === '[current-page:query:search]') {
          searchToken.innerHTML = '';
        }
      }

      // Wrap table if overflow wrap isn't set.
      if (!$('table').parent().hasClass('jsa-overflow-auto')) {
        $('table').wrap('<div class="jsa-overflow-auto"></div>');
      }

      // toggle functionality
      $('.form-control-toggle__switch-checkbox').each(function () {

        // Toggle selected values
        function toggleChange() {
          if ($('.form-control-toggle__switch-checkbox').is(':checked')) {
            $('.form-control-toggle__switch-checkbox-label').html('On');
            $('.form-control-toggle__switch-checkbox').attr('aria-checked', 'true');
          } else {
            $('.form-control-toggle__switch-checkbox-label').html('Off');
            $('.form-control-toggle__switch-checkbox').attr('aria-checked', 'false');
          }
        }

        // on load set the values
        toggleChange();
        // on change set the values
        $(this).change(function () {
          toggleChange();
        });
        // on enter toggle the values
        $(this).keypress(function (e) {
          if (e.which === 13) {
            e.preventDefault();
            e.target.click();
          }
        });
      });

      // Prevent looping.
      if (!initialized) {
        initialized = true;
        // Event Listener for the nested oembed iframe.
        window.addEventListener('message', function (e) {
          if (e.origin.includes('unitedrentals') && e.data instanceof Object && 'event' in e.data) {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push(e.data);
          }
        }, false);
      }

      // Pass in Fullstory identify parameters.
      if (typeof drupalSettings === 'object' && drupalSettings.user.uid !== 0) {
        if (window.FS) {
          // If library is already loaded run the identify function right away.
          window.FS.identify(drupalSettings.user.uid, {
            displayName: drupalSettings.user.name,
            email: drupalSettings.user.email,
          });
          window.FS.setUserVars({
            accountNumber: drupalSettings.user.defaultAccountId,
            accountName: drupalSettings.user.defaultAccountName,
            accountLevel: drupalSettings.user.isEmployee ? 'E' : 'C',
            accountParent: drupalSettings.user.defaultParentAccountId,
            level: drupalSettings.fs || '',
          });
        } else {
          // If library is not loaded then we use Fullstory's callback to load the identify function.
          window['_fs_ready'] = function () {
            FS.identify(drupalSettings.user.uid, {
              displayName: drupalSettings.user.name,
              email: drupalSettings.user.email,
            });
            FS.setUserVars({
              accountNumber: drupalSettings.user.defaultAccountId,
              accountName: drupalSettings.user.defaultAccountName,
              accountLevel: drupalSettings.user.isEmployee ? 'E' : 'C',
              accountParent: drupalSettings.user.defaultParentAccountId,
              level: drupalSettings.fs || '',
            });
          };
        }
      }

      // Safari blazy / lazyload fix to force responsive images to redraw.
      if (typeof window.safari !== 'undefined') {
        setTimeout(function () {
          const $picture = $(once('blazy-fix', 'picture', context));
          $picture.prepend('<source>');
        }, 500);
      }
    }
  };

  // Adding these field state additions outside a behavior to mimic what states.js does in core.
  const $states_alt_label = $(once('states-alt-label', document));
  $states_alt_label.on('state:alt-label', function (e) {
    if (e.trigger) {
      var $label = $(e.target).find('label').first();
      if (!$(e.target).data('states-alt-label-default')) {
        $(e.target).data('states-alt-label-default', $label.text());
      }
      if (e.value) {
        $label.text($(e.target).data('states-alt-label'));
      }
      else {
        $label.text($(e.target).data('states-alt-label-default'));
      }
    }
  });

  const $states_alt_value = $(once('state:alt-value', document));
  $states_alt_value.on('state:alt-value', function (e) {
    if (e.trigger) {
      if (!$(e.target).data('states-alt-value-default')) {
        $(e.target).data('states-alt-value-default', $(e.target).val());
      }
      if (e.value) {
        $(e.target).val($(e.target).data('states-alt-value'));
      }
      else {
        $(e.target).val($(e.target).data('states-alt-value-default'));
      }
    }
  });

  const $states_alt_placeholder = $(once('states:alt-placeholder', document));
  $states_alt_placeholder.on('state:alt-placeholder', function (e) {
    if (e.trigger) {
      var $textarea = $(e.target).find('textarea').first();
      if (!$(e.target).data('states-alt-placeholder-default')) {
        $(e.target).data('states-alt-placeholder-default', $textarea.attr('placeholder'));
      }
      if (e.value) {
        $textarea.attr('placeholder', $(e.target).data('states-alt-placeholder'));
      }
      else {
        $textarea.attr('placeholder', $(e.target).data('states-alt-placeholder-default'));
      }
    }
  });
})(Drupal, jQuery, once, drupalSettings);
